import PriceBoostBannerImpl from './price-boost-banner.js';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;
const { types: BetslipTypes } = MojitoServices.Betslip;

/**
 * Price boost banner.
 *
 * @class PriceBoostBanner
 * @memberof Mojito.Modules
 */

/**
 * PriceBoostBanner prop types.
 *
 * @property {object} selection - The selection to be displayed.
 * @property {object} event - The parent event.
 * @property {object} market - The parent market.
 * @property {string} basePrice - The base price for the boosted selection.
 * @property {Mojito.Services.Betslip.types.BETTING_CONTEXT} [bettingContext = BETTING_CONTEXT.DEFAULT] - Selection betting context. This context represents betting flow.
 *
 * @memberof Mojito.Modules.PriceBoostBanner
 */
const propTypes = {
    selection: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    basePrice: PropTypes.string.isRequired,
    bettingContext: PropTypes.string,
};

const defaultProps = {
    bettingContext: BetslipTypes.BETTING_CONTEXT.DEFAULT,
};

export default UIView('PriceBoostBanner', PriceBoostBannerImpl, propTypes, defaultProps);
